module.exports = __webpack_public_path__ + "franchise-08.png?5ec5dbc178975e92cdde9dd667479ca2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/franchise-08.png
// module id = 269
// module chunks = 0